
<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";

export default {
  mixins: [navigation],
  name: "app",
  deactivated() {
    this.time = 135;
    this.timer = null;
  },
  activated() {
    if (!this.timer) {
      this.timer = setInterval(() => {
        if (this.time > 0 && !this.sent) {
          this.time--;
        } else {
          clearInterval(this.timer);
          if (!this.sent) {
            this.sendResult();
            this.nextPage(this.next);
          }
        }
      }, 1000);
    }
  },
  data() {
    return {
      last: "P_47",
      next: "P_49",
      topic: "Estás en: Taller ¿Qué es crédito? / ¿Qué aprendí en esta lección?",
      selected: [],
      feedback: false,
      dialog: false,
      respuesta: "none",
      response: 0,
      sent: false,
      show: false,
      correcta: 2,
      time: 6,
      timer: null,
      interaction: {
        id: "TCC.L1.p3",
        questionText: "Selecciona la opción",
        learnerResponse: "",
        correctAnswer: "",
        wasCorrect: true
      },
      reactivos: [
        {
          descripcion: "Comprobando que tengas por lo menos una propiedad a tu nombre."
        },
        {
          descripcion: "Revisando los historiales crediticios de tus familiares. "
        },
        {
          descripcion: "Verificando tu historial de comportamiento con otros créditos."
        },
        {
          descripcion: "Solicitando tu estado de cuenta. "
        }
      ],
    };
  },
  computed: {
    responseIsNone() {
      return {
        "btn-primary": this.respuesta != "none",
        "btn-secondary": this.respuesta == "none"
      };
    },
    checkResult() {
      return {
        done: this.response != "none",
        clear: this.response == "none"
      };
    }
  },
  methods: {
    sendResult() {
      if (this.respuesta == this.correcta) {
        this.response = 1;
      }
      this.sent = true;
      eventBus.$emit("send_result", this.response);
    },
  }
};
</script>

<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(:back='last') {{topic}}
            v-card-text.text-xs-center.label16tt.withDivider
              | PREGUNTA 3 DE 5
            img.pt-3(style="width:61px; heigth:67px;", src="@/assets/cronometro.gif")
            v-card-text.chrono
              b {{("0" + Math.floor(time / 60)).slice(-2) +":" + ("0"+(time - Math.floor(time / 60) * 60)).slice(-2)}}
            v-card-text.titulo24Reg
              | Para que el banco te otorgue un crédito es importante que compruebe que tu salud financiera te permitirá enfrentar con éxito el compromiso. 
            v-card-text.parrafoDestacadoB.text-center  ¿Cuál es la forma más común de saber si podrás cubrir los pagos de tu crédito? 
            v-card.questionCard(justify-center, flat)
              v-radio-group(v-model='respuesta')
                v-layout.ml-5(v-for='(reactivo, index) in reactivos', :key='index')
                  v-flex.iconos.text-xs-center.pt-3(xs1, align-center, align-content-center)
                    div(v-if='sent && (correcta == index || respuesta == index)')
                      v-icon(size='15px', color='green', v-if='sent && (correcta == index)') fas fa-check
                      v-icon(size='15px', color='red', v-if='sent && (correcta != index)') fas fa-times
                  v-flex.iconos.text-xs-right(xs1, align-content-center)
                    v-radio(hide-details, :value='index')
                  v-flex.label16tt_blue.text-xs-left.pr-5(xs12, align-content-center)
                    div(style="display:inline;" v-html="reactivo.descripcion").pr-5.parrafoDestacadoB
            v-layout(row, justify-center)
              v-flex
                div(v-if='sent==false')
                  v-btn.btn(color='secondary', v-bind:class='responseIsNone', :disabled="respuesta=='none'", @click='sendResult()')
                    | Enviar
                div(v-if='sent')
                  v-btn.btn(color='accent', style='z-index:2', @click.prevent='dialog=true')
                    | Retroalimentación
                  v-dialog(v-model='dialog', persistent, max-width='930px', content-class="dialog_over")
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card
                          .pt-1.pr-2(v-if='sent && (respuesta===correcta)')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='@/assets/ManoOk.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Tu respuesta es correcta!
                          .pt-1.pr-2(v-if='sent && (respuesta!==correcta)')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='@/assets/ManoStop.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Lo sentimos!
                          v-card.px-5.questionCard(justify-center, flat)
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta===correcta)')
                              v-card-text.dialog_text
                                | Para enfrentar con éxito el compromiso de un crédito, debes tener un buen historial crediticio. Además, es importante verificar que tengas buenas referencias y capacidad de pago.
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta!==correcta)')
                              v-card-text.dialog_text
                                | Esta vez tu respuesta no es correcta. Recuerda que para saber si podrás pagar un crédito debes conocer el historial crediticio. Además es importante verificar que tengas buenas referencias y capacidad de pago.
                          v-btn.btn.dialog_btn.my-4(color='accent', @click.prevent="nextPage(next)")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')
</template>
